import React, { useEffect, useState } from "react";
import { formatPlanParams, isPlanAssignable } from "../lib/planStatus";
import { approveTenant, assignPlanToTenant, fetchPlanCatalog } from "../lib/opsGraphql";

export default function ApproveTenantModal({ tenant, onClose, onSuccess, loading: parentLoading }) {
  const [step, setStep] = useState(1);
  const [plans, setPlans] = useState([]);
  const [planId, setPlanId] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const busy = loading || parentLoading;
  const assignable = plans.filter(isPlanAssignable);
  const selected = assignable.find((p) => p.plan_id === planId);

  useEffect(() => {
    fetchPlanCatalog()
      .then((rows) => {
        setPlans(rows);
        const first = rows.find(isPlanAssignable);
        if (first) setPlanId(first.plan_id);
      })
      .catch((e) => setError(e.message));
  }, []);

  const handleApprove = async () => {
    if (!planId) {
      setError("Seleccioná un plan");
      return;
    }
    setLoading(true);
    setError("");
    try {
      await approveTenant(tenant.tenant_id);
      await assignPlanToTenant(tenant.tenant_id, planId);
      onSuccess?.();
      onClose();
    } catch (e) {
      setError(e.message || "No se pudo aprobar el tenant");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ops-modal-backdrop">
      <div className="ops-modal ops-modal-wide">
        <div className="ops-step-indicator">
          <span className={step === 1 ? "active" : ""}>1. Revisión</span>
          <span className={step === 2 ? "active" : ""}>2. Asignar plan</span>
        </div>

        {step === 1 && (
          <>
            <h3>Aprobar tenant</h3>
            <p>
              <strong>{tenant.name}</strong>
              <br />
              <code>{tenant.tenant_id}</code>
            </p>
            <p className="ops-subtitle">
              Estado: {tenant.status} · Creado: {tenant.created_at || "—"}
            </p>
            <p>Al continuar deberás asignar un plan del catálogo antes de activar el tenant.</p>
            <div className="ops-actions">
              <button type="button" className="ops-btn secondary" onClick={onClose}>
                Cancelar
              </button>
              <button type="button" className="ops-btn" onClick={() => setStep(2)}>
                Continuar →
              </button>
            </div>
          </>
        )}

        {step === 2 && (
          <>
            <h3>Plan para {tenant.name}</h3>
            {error && <p className="ops-error">{error}</p>}
            <label>
              Plan comercial
              <select value={planId} onChange={(e) => setPlanId(e.target.value)}>
                <option value="">Seleccionar…</option>
                {assignable.map((p) => (
                  <option key={p.plan_id} value={p.plan_id}>
                    {p.name}
                  </option>
                ))}
              </select>
            </label>
            {selected && <p className="ops-plan-preview">{formatPlanParams(selected)}</p>}
            {assignable.length === 0 && (
              <p className="ops-error">No hay planes activos en el catálogo. Creá uno en /planes.</p>
            )}
            <div className="ops-actions" style={{ marginTop: 16 }}>
              <button type="button" className="ops-btn secondary" onClick={() => setStep(1)} disabled={busy}>
                ← Volver
              </button>
              <button type="button" className="ops-btn" onClick={handleApprove} disabled={busy || !planId}>
                {busy ? "Aprobando…" : "Aprobar y asignar plan"}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
